/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw, Copy } from 'lucide-react'
import toast, { Toaster } from 'react-hot-toast'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Nav,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import InputDatePicker from '../../components/Input/DatePicker/InputDatePicker'
import Loader from '../../components/atoms/Loader/index'
import TablePagination from '../../components/atoms/Table/TablePagination'
import ModalItemIssue from '../../components/modal/ItemIssue/ModalItemIssue'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../config/AxiosInstance'
import { convertDateWithTime, transformKey } from '../../helpers/constants'
import '../../styles/style.css'
import { firstLetterUpperCase } from '../../utils/TextFormatter'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  backgroundColor: '#f8f9fa',
  color: '#333333',
  fontWeight: '700',
  borderBottom: '1px solid #e9ecef',
  textTransform: 'uppercase',
  fontSize: '0.85rem',
  whiteSpace: 'nowrap'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const FormControlStyle = {
  border: '1px solid #e9ecef',
  borderRadius: '8px',
  padding: '0.6rem 1rem',
  fontSize: '0.9rem',
  backgroundColor: '#ffffff',
  transition: 'all 0.2s',
  height: '45px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '45px',
    borderRadius: '8px',
    border: '1px solid #e9ecef',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(248, 157, 29, 0.2)' : 'none',
    '&:hover': {
      borderColor: '#f89d1d'
    }
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#f89d1d'
      : state.isFocused
        ? '#fff5e6'
        : '#fff',
    color: state.isSelected ? '#fff' : '#333',
    '&:active': {
      backgroundColor: '#f89d1d'
    }
  }),
  placeholder: (base) => ({
    ...base,
    color: '#adb5bd',
    fontSize: '0.9rem'
  }),
  singleValue: (base) => ({
    ...base,
    color: '#333',
    fontSize: '0.9rem'
  })
}

const ItemIssue = () => {
  const navigate = useNavigate()
  const customStyles = {
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      color: 'black',
      border: '1.2px solid #F1F2F7',
      padding: '1px',
      borderRadius: '5px',
      fontSize: '14px',
      flexDirection: 'row-reverse'
    }),
    control: (base) => ({
      ...base,
      height: 37,
      minHeight: 37
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '37px',
      padding: '0 6px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px'
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  }
  const { state } = useLocation()
  const refPics = useRef(null)
  const refCheckers = useRef(null)
  const [warehouse, setWarehouse] = useState([])
  const [visible, setVisible] = useState(false)
  const [visibleManualStockOpname, setVisibleManualStockOpname] = useState({
    confirm: false,
    form: false
  })
  const [formManualStockOpname, setFormManualStockOpname] = useState({
    pics: state?.pics || [],
    checkers: state?.checkers || []
  })
  const [filter, setFilter] = useState({
    warehouse_id: state?.warehouse_id || null,
    date_start: null,
    date_end: null,
    problem: null,
    q: ''
  })
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [itemIssues, setItemIssues] = useState([])
  const [selectedID, setSelectedID] = useState(state?.selectedID || [])
  const [typeWarehouse, setTypeWarehouse] = useState(
    state?.typeWarehouse || 'internal'
  )
  const [users, setUsers] = useState({
    pics: [],
    checkers: []
  })
  const [type, setType] = useState('waiting')
  const [loading, setLoading] = useState(false)
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(filter.q)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [filter.q])

  const renderItemProblem = (data) => {
    if (data.item_problem === 'barang_hilang') {
      return 'Barang Tidak Ada'
    } else if (data.item_problem === 'damaged') {
      return 'Rusak'
    }
    return !data.item_problem ? '-' : transformKey(data.item_problem)
  }

  const getLink = (data) => {
    let url = ''
    if (data.item_reference_type === 'transfer') {
      url = `/transfer/transfer-area/detail/${data.item_reference_id}`
    }
    return url
  }

  const getLinkSettled = (data) => {
    let url = ''
    if (data.settled_ticket_type === 'transfer') {
      url = `/transfer/transfer-area/detail/${data.settled_ticket_id}`
    }
    return url
  }

  const COLUMNS_WAITING = [
    { key: 'checkbox', label: 'Checkbox' },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (data) => `${data.item_code} - ${data.item_name}`
    },
    {
      key: 'batch',
      label: 'Batch',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data.batch ?? '-'}

          {data.batch && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.batch)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'base_uom_qty',
      label: 'Base UOM Qty',
      component: (data) =>
        `${data.total_qty ? parseFloat(data.total_qty).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'} ${data.uom_qty ?? ''}`
    },
    {
      key: 'qty_kemasan',
      label: 'Qty Kemasan',
      component: (data) =>
        `${data.total_pack ? parseFloat(data.total_pack).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'} ${data.uom_pack ? data.uom_pack.toLowerCase() : ''}`
    },
    {
      key: 'slot',
      label: 'Slot Location',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data.slot ?? '-'}

          {data.slot && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.slot)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'palet',
      label: 'Palet',
      component: (data) => data.palet_code ?? '-'
    },
    {
      key: 'item_problem',
      label: 'Problem',
      component: (data) => renderItemProblem(data)
    },
    {
      key: 'item_reference',
      label: 'Related Ticket',
      component: (data) => (
        <div key={`${data.issue_id}-reference`}>
          {getLink(data) === '' && (
            <span
              style={{
                color: `${data.item_reference ? '#2F80ED' : 'black'}`,
                cursor: 'not-allowed'
              }}
            >
              {data.item_reference ?? '-'}
            </span>
          )}
          {getLink(data) !== '' && (
            <Link
              to={getLink(data)}
              className="text-decoration-none"
              state={{ code: data.item_reference }}
            >
              {data.item_reference}
            </Link>
          )}

          {data.item_reference && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.item_reference)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    { key: 'report_date', label: 'Report Date' },
    {
      key: 'report_by',
      label: 'By',
      component: (data) =>
        data.report_by ? firstLetterUpperCase(data.report_by) : '-'
    },
    {
      key: 'last_update',
      label: 'Last Update',
      component: (data) =>
        data.last_updated_at
          ? moment(data.last_updated_at).format('DD-MM-YYYY')
          : '-'
    }
  ]

  const COLUMNS_HISTORY = [
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (data) => `${data.item_code} - ${data.item_name}`
    },
    {
      key: 'batch',
      label: 'Batch',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data.batch ?? '-'}

          {data.batch && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.batch)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'base_uom_qty',
      label: 'Base UOM Qty',
      component: (data) =>
        `${data.total_qty ? parseFloat(data.total_qty).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'} ${data.uom_qty ?? ''}`
    },
    {
      key: 'qty_kemasan',
      label: 'Qty Kemasan',
      component: (data) =>
        `${data.total_pack ? parseFloat(data.total_pack).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'} ${data.uom_pack ? data.uom_pack.toLowerCase() : ''}`
    },
    {
      key: 'slot',
      label: 'Slot Location',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data.slot ?? '-'}

          {data.slot && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.slot)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'palet',
      label: 'Palet',
      component: (data) => data.palet_code ?? '-'
    },
    {
      key: 'item_problem',
      label: 'Problem',
      component: (data) => renderItemProblem(data)
    },
    {
      key: 'item_reference',
      label: 'Related Ticket',
      component: (data) => (
        <div key={`${data.issue_id}-reference`}>
          {getLink(data) === '' && (
            <span
              style={{
                color: `${data.item_reference ? '#2F80ED' : 'black'}`,
                cursor: 'not-allowed'
              }}
            >
              {data.item_reference ?? '-'}
            </span>
          )}
          {getLink(data) !== '' && (
            <Link
              to={getLink(data)}
              className="text-decoration-none"
              state={{ code: data.item_reference }}
            >
              {data.item_reference}
            </Link>
          )}

          {data.item_reference && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.item_reference)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    { key: 'report_date', label: 'Report Date' },
    {
      key: 'report_by',
      label: 'By',
      component: (data) =>
        data.report_by ? firstLetterUpperCase(data.report_by) : '-'
    },
    {
      key: 'settled_type',
      label: 'Settlement',
      component: (data) =>
        data.settled_type ? firstLetterUpperCase(data.settled_type) : '-'
    },
    {
      key: 'settled_ticket',
      label: 'Settlement Ticket',
      component: (data) => (
        <div key={`${data.issue_id}-settled`}>
          {getLinkSettled(data) === '' && (
            <span
              style={{
                color: `${data.settled_ticket ? '#2F80ED' : 'black'}`,
                cursor: 'not-allowed'
              }}
            >
              {data.settled_ticket ?? '-'}
            </span>
          )}
          {getLinkSettled(data) !== '' && (
            <Link
              to={getLinkSettled(data)}
              className="text-decoration-none"
              state={{ code: data.settled_ticket }}
            >
              {data.settled_ticket}
            </Link>
          )}
        </div>
      )
    },
    {
      key: 'settled_by',
      label: 'By',
      component: (data) =>
        data.settled_by ? firstLetterUpperCase(data.settled_by) : '-'
    }
  ]
  const [columns, setColumns] = useState(COLUMNS_WAITING)

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: 1,
        type: typeWarehouse,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const formattedWarehouses = response.data.data.map((w) => ({
        value: w.id,
        label: w.warehouse_name
      }))
      setWarehouse(formattedWarehouses)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  const handleForm = (value, name) => {
    setFormManualStockOpname((prevForm) => ({
      ...prevForm,
      [name]: value
    }))
  }
  const fetchUsers = async () => {
    try {
      const payload = {
        warehouse_id: filter.warehouse_id?.value || ''
      }
      const responseChecker = await api.post('/stock-opname/users', {
        ...payload,
        type: 'checker'
      })
      const responsePic = await api.post('/stock-opname/users', {
        ...payload,
        type: 'pic'
      })
      const { data: dataCheckers } = responseChecker.data
      const { data: dataPics } = responsePic.data
      setUsers({
        checkers: dataCheckers.map((checker) => ({
          value: checker.id,
          label: checker.name
        })),
        pics: dataPics.map((pic) => ({
          value: pic.id,
          label: pic.name
        }))
      })
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({ ...prevMeta, current_page: data.selected + 1 }))
    window.scrollTo(0, 0)
  }

  const handleSelectType = (typeValue) => {
    setType(typeValue)
    setColumns(typeValue === 'waiting' ? COLUMNS_WAITING : COLUMNS_HISTORY)
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: 1
    }))
  }

  const handleChangeCheckbox = (value = null) => {
    if (!value) {
      if (selectedID.length > 0) {
        setSelectedID([])
      } else {
        const checkedProblemLabel = itemIssues.every(
          (itemIssue) => itemIssue.item_problem === itemIssues[0].item_problem
        )
        if (!checkedProblemLabel) {
          return toast.error('Please select the same problem label', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
        }
        setSelectedID(
          itemIssues.map((itemIssue) => ({
            id: itemIssue.issue_id,
            problem: itemIssue.item_problem
          }))
        )
      }
    } else {
      const checkedProblemLabel =
        selectedID.length > 0 &&
        selectedID.some((valueID) => valueID.problem !== value.problem)
      if (checkedProblemLabel) {
        return toast.error('Please select the same problem label', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } else {
        setSelectedID((prevSelectedID) => {
          if (prevSelectedID.find((item) => item.id === value.id)) {
            return prevSelectedID.filter((item) => item.id !== value.id)
          } else {
            return [...prevSelectedID, value]
          }
        })
      }
    }
  }

  const handleModalCreateTicketCancelIssue = () => {
    let title = 'Cancel Issue?'
    let text = 'Item in slot will be visible affter issue(s) completed'
    let confirmButtonText = 'Cancel Issue'
    let cancelButtonText = 'Keep Issue'
    Swal.fire({
      title,
      text,
      icon: 'warning',
      iconColor: '#828282',
      showCancelButton: true,
      confirmButtonColor: '#f89d1d',
      confirmButtonText,
      cancelButtonText,
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-cancel-pr'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let url = '/item-issue/cancel'
          const payload = {
            problem: selectedID[0].problem,
            issue_ids: selectedID.map((item) => item.id)
          }
          const res = await api.post(url, payload)
          const { status } = res
          if (status === 200) {
            toast.success('Cancel Issue Success!', {
              position: 'top-right',
              style: {
                fontSize: '14px',
                fontWeight: '600'
              }
            })
            setSelectedID([]) // when success reset to empty array
            getData()
          }
        } catch (err) {
          const errMsg =
            err?.response?.data?.errors?.message || 'An error occurred'
          toast.error(errMsg, {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
        }
      }
    })
  }

  const columnsMemo = useMemo(() => columns, [columns])

  const handleResetSelectedID = () => {
    setSelectedID([])
  }

  const handleResetFilters = () => {
    setFilter({
      ...filter,
      warehouse_id: null,
      date_start: null,
      date_end: null,
      problem: null,
      q: ''
    })
    setDebouncedSearch('')
  }

  const handleDisableButtonCreate = useCallback(
    (type) => {
      if (!selectedID.length) {
        return true
      }
      if (
        type === 'cancel_issue' &&
        selectedID.length > 0 &&
        ['barang_hilang', 'expired'].includes(selectedID[0]?.problem)
      ) {
        return true
      }
      if (
        type === 'create_transfer' &&
        selectedID.length > 0 &&
        selectedID[0]?.problem === 'barang_hilang'
      ) {
        return true
      }
      return false
    },
    [selectedID, type]
  )

  const getData = async () => {
    try {
      setLoading(true)
      const params = {
        type: type === 'waiting' ? 'waiting' : 'history',
        warehouse_id: filter.warehouse_id?.value,
        problem: filter.problem?.value,
        start_date: filter.date_start
          ? convertDateWithTime(filter.date_start, 'YYYY-MM-DD')
          : '',
        end_date: filter.date_end
          ? convertDateWithTime(filter.date_end, 'YYYY-MM-DD')
          : '',
        q: debouncedSearch,
        page: meta.current_page,
        per_page: meta.per_page
      }
      const response = await api.get('/item-issue', { params })
      const { data, metadata } = response.data
      setItemIssues(data)
      setMeta(metadata)
    } catch (err) {
      if (err?.response?.status !== 404) {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } else {
        setItemIssues([])
      }
    } finally {
      setLoading(false)
    }
  }
  const handleModalManualStockOpname = (type = null, action = null) => {
    if (type) {
      setVisibleManualStockOpname((prev) => ({
        ...prev,
        [type]: !prev[type]
      }))
    } else {
      const modalKeyOpen = Object.keys(visibleManualStockOpname).find(
        (value) => visibleManualStockOpname[value]
      )
      // create opposite modal open value based on value modalKeyOpen
      const openValue = !visibleManualStockOpname[modalKeyOpen]
      if (modalKeyOpen === 'confirm') {
        setVisibleManualStockOpname((prev) => ({
          ...prev,
          confirm: openValue
        }))
        if (action) {
          setTimeout(() => {
            setVisibleManualStockOpname((prev) => ({
              ...prev,
              form: true
            }))
          }, 500)
        }
        if (!action && !openValue) {
          setFormManualStockOpname({
            pics: [],
            checkers: []
          })
          if (state?.isCancel) {
            const { pics, checkers, item_issues, isCancel, ...newState } = state
            navigate('/item-issue', {
              state: newState
            })
          }
        }
      } else {
        setVisibleManualStockOpname((prev) => ({
          ...prev,
          form: openValue
        }))
        if (!openValue) {
          setFormManualStockOpname({
            pics: [],
            checkers: []
          })
        }
        setTimeout(() => {
          setVisibleManualStockOpname((prev) => ({
            ...prev,
            confirm: true
          }))
        }, 500)
      }
    }
  }
  const ModalManualStockOpnameProp = useCallback(() => {
    if (visibleManualStockOpname.confirm) {
      return {
        title: '',
        key: 'confirm',
        footer: (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex gap-2">
              <Button
                variant="transparent"
                onClick={() => handleModalManualStockOpname()}
              >
                Cancel
              </Button>
              <Button
                variant="transparent"
                className="btn-primary-orange"
                onClick={() => handleModalManualStockOpname(null, 'next')}
              >
                Create
              </Button>
            </div>
          </div>
        )
      }
    }
    if (visibleManualStockOpname.form) {
      let item_issues = []
      const itemIssueSelectes =
        selectedID.map((itemIssue) => itemIssue.id) || []
      if (itemIssueSelectes.length > 0) {
        item_issues = itemIssues
          .filter((itemIssue) => itemIssueSelectes.includes(itemIssue.issue_id))
          .map((itemIssueMap) => ({
            slot: itemIssueMap.slot,
            batch: itemIssueMap.batch
          }))
      }
      return {
        title: 'Select Team',
        key: 'form',
        footer: (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex gap-2">
              <Button
                variant="transparent"
                className={
                  formManualStockOpname.pics.length > 0 &&
                  formManualStockOpname.checkers.length > 0 &&
                  item_issues.length > 0
                    ? 'btn-primary-orange'
                    : 'btn-secondary opacity-25'
                }
                onClick={() =>
                  navigate('/stock-opname/manual-stock-opname/create', {
                    state: {
                      warehouse_id: filter.warehouse_id?.value || '',
                      ...formManualStockOpname,
                      item_issues,
                      selectedID: selectedID
                    }
                  })
                }
              >
                Submit
              </Button>
            </div>
          </div>
        )
      }
    }
    return {
      title: '',
      key: undefined,
      footer: null
    }
  }, [visibleManualStockOpname, formManualStockOpname, selectedID, itemIssues])

  useEffect(() => {
    fetchWarehouse()
  }, [])
  useEffect(() => {
    if (state?.isCancel) {
      setVisibleManualStockOpname((prev) => ({
        ...prev,
        confirm: true
      }))
    }
  }, [state?.isCancel])

  useEffect(() => {
    if (filter.warehouse_id) {
      if (
        (filter.date_start && !filter.date_end) ||
        (!filter.date_start && filter.date_end)
      ) {
        return
      }
      getData()
    } else {
      setItemIssues([])
    }
  }, [
    meta.per_page,
    meta.current_page,
    type,
    filter.warehouse_id,
    filter.problem,
    filter.date_start,
    filter.date_end,
    debouncedSearch
  ])

  useEffect(() => {
    if (visibleManualStockOpname.form) {
      fetchUsers() // call your async fetch function here
    }
  }, [visibleManualStockOpname.form])

  const problemOptions = [
    { value: 'bocor', label: 'Bocor' },
    { value: 'damaged', label: 'Rusak' },
    { value: 'tidak_ada_label', label: 'Tidak Ada Label' },
    { value: 'tidak_ada_segel', label: 'Tidak Ada Segel' },
    { value: 'coa_not_match', label: 'Coa Not Match' },
    { value: 'expired', label: 'Expired' },
    { value: 'barang_hilang', label: 'Barang Tidak Ada' }
  ]

  return (
    <Container fluid className="px-4">
      <Toaster />
      <Row>
        <Col>
          <h3 style={headerTitleStyle}>Item Issue</h3>
        </Col>
      </Row>
      <Row className="mt-3 mb-4">
        <Col md={12} className="position-relative">
          <Nav
            variant="underline"
            defaultActiveKey={type}
            style={{ zIndex: '20' }}
          >
            <Nav.Item>
              <Nav.Link
                eventKey={'waiting'}
                onClick={() => handleSelectType('waiting')}
                style={{
                  color: `${type === 'waiting' ? 'black' : 'grey'}`,
                  fontWeight: type === 'waiting' ? 'bold' : 'normal'
                }}
              >
                Waiting
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey={'history'}
                onClick={() => handleSelectType('history')}
                style={{
                  color: `${type === 'history' ? 'black' : 'grey'}`,
                  fontWeight: type === 'history' ? 'bold' : 'normal'
                }}
              >
                History
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div
            className="position-absolute top-100 w-100"
            style={{ zIndex: '-1' }}
          >
            <div
              style={{
                width: '100%',
                height: '1px',
                backgroundColor: '#e9ecef',
                zIndex: '-1',
                marginTop: '-1px'
              }}
            />
          </div>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="g-3">
          <Col md={3}>
            <Form.Label style={labelStyle}>Warehouse</Form.Label>
            <Select
              options={warehouse}
              value={filter.warehouse_id}
              onChange={(option) => {
                setFilter({ ...filter, warehouse_id: option })
                setMeta((prev) => ({ ...prev, current_page: 1 }))
                if (users.checkers.length > 0 || users.pics.length > 0) {
                  setUsers({
                    checkers: [],
                    pics: []
                  })
                }
              }}
              placeholder="Select Warehouse..."
              styles={SelectStyles}
            />
          </Col>
          <Col md={6}>
            <Form.Label style={labelStyle}>Date Range</Form.Label>
            <InputGroup className="gap-2">
              <div style={{ flex: 1 }}>
                <InputDatePicker
                  value={filter.date_start}
                  onChange={(value) => {
                    const newFilter = { ...filter, date_start: value }
                    if (
                      value &&
                      filter.date_end &&
                      moment(value) > moment(filter.date_end)
                    ) {
                      newFilter.date_end = value
                    }
                    setFilter(newFilter)
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  clearIcon
                  maxDate={filter.date_end ? new Date(filter.date_end) : null}
                  className="date-picker-45"
                />
              </div>
              <div className="d-flex align-items-center text-muted">-</div>
              <div style={{ flex: 1 }}>
                <InputDatePicker
                  value={filter.date_end}
                  onChange={(value) => {
                    const newFilter = { ...filter, date_end: value }
                    if (
                      value &&
                      filter.date_start &&
                      moment(value) < moment(filter.date_start)
                    ) {
                      newFilter.date_start = value
                    }
                    setFilter(newFilter)
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  clearIcon
                  minDate={
                    filter.date_start ? new Date(filter.date_start) : null
                  }
                  className="date-picker-45"
                />
              </div>
            </InputGroup>
          </Col>
          <Col md={3} className="d-flex align-items-end">
            <Button
              variant="light"
              className="w-100 rounded shadow-sm"
              style={{
                height: '45px',
                borderColor: '#e9ecef',
                color: '#6c757d',
                fontWeight: '600'
              }}
              onClick={handleResetFilters}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
          </Col>
        </Row>

        {type === 'waiting' && (
          <Row className="g-3 mt-1">
            <Col md={3}>
              <Form.Label style={labelStyle}>Problem</Form.Label>
              <Select
                options={problemOptions}
                value={filter.problem}
                onChange={(option) => {
                  setFilter({ ...filter, problem: option })
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                placeholder="All Problems"
                styles={SelectStyles}
                isClearable
              />
            </Col>
            <Col md={9}>
              <Form.Label style={labelStyle}>Search</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#ffffff',
                    borderRight: 'none',
                    borderTopLeftRadius: '8px',
                    borderBottomLeftRadius: '8px',
                    borderColor: '#e9ecef'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search Item Code or Name..."
                  value={filter.q}
                  onChange={(e) => setFilter({ ...filter, q: e.target.value })}
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: '0',
                    borderBottomLeftRadius: '0'
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
        )}
      </Card>

      {type === 'waiting' && (
        <Row className="mb-4">
          <div className="d-flex flex-row gap-2 justify-content-end">
            <Button
              type="button"
              className={`rounded shadow-sm px-4 fw-bold ${
                !handleDisableButtonCreate('cancel_issue')
                  ? 'btn-primary-blue text-light'
                  : 'btn-secondary opacity-50'
              }`}
              style={{ border: 'none', minWidth: '130px' }}
              onClick={() => handleModalCreateTicketCancelIssue()}
              disabled={handleDisableButtonCreate('cancel_issue')}
            >
              Cancel Issue
            </Button>
            <Button
              type="button"
              className={`rounded shadow-sm px-4 fw-bold ${
                !handleDisableButtonCreate('create_transfer')
                  ? 'btn-primary-orange text-light'
                  : 'btn-secondary opacity-50'
              }`}
              style={{ border: 'none', minWidth: '130px' }}
              onClick={() => setVisible(true)}
              disabled={handleDisableButtonCreate('create_transfer')}
            >
              Create Ticket
            </Button>
            <Button
              type="button"
              className={`rounded shadow-sm px-4 fw-bold ${
                !handleDisableButtonCreate('manual_stock_opname')
                  ? 'btn-primary-orange text-light'
                  : 'btn-secondary opacity-50'
              }`}
              style={{ border: 'none', minWidth: '180px' }}
              disabled={handleDisableButtonCreate('manual_stock')}
              onClick={() => handleModalManualStockOpname('confirm')}
            >
              Manual Stock Opname
            </Button>
          </div>
        </Row>
      )}

      <div className="row">
        <div className="col-12">
          <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
            <Table
              hover
              responsive
              className="mb-0 b-table-frameless text-nowrap"
            >
              <thead style={tableHeaderStyle}>
                <tr>
                  {columns.map((column) => (
                    <th className="align-middle p-2" key={column.key}>
                      {column.key === 'checkbox' ? (
                        <input
                          type="checkbox"
                          className="staging-area form-check-input"
                          checked={
                            itemIssues?.length !== 0 &&
                            itemIssues?.length === selectedID.length
                          }
                          disabled={!itemIssues?.length}
                          onChange={() => handleChangeCheckbox()}
                          role="button"
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <span>{column.label}</span>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={columns.length} className="p-5 text-center">
                      <Loader />
                    </td>
                  </tr>
                ) : itemIssues.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="p-5 text-center text-muted"
                    >
                      No data available
                    </td>
                  </tr>
                ) : (
                  itemIssues.map((itemIssue, indexItemIssue) => (
                    <tr key={indexItemIssue}>
                      {columnsMemo.map((column) => (
                        <td
                          key={column.key}
                          className="p-2 align-middle text-nowrap"
                        >
                          {column.key === 'checkbox' ? (
                            <input
                              type="checkbox"
                              className="staging-area form-check-input"
                              value={itemIssue.issue_id || ''}
                              checked={
                                !!selectedID.find(
                                  (selectId) =>
                                    selectId.id === itemIssue.issue_id
                                )
                              }
                              onChange={() =>
                                handleChangeCheckbox({
                                  id: itemIssue.issue_id,
                                  problem: itemIssue?.item_problem
                                })
                              }
                              role="button"
                              style={{ cursor: 'pointer' }}
                            />
                          ) : column.component ? (
                            column.component(itemIssue)
                          ) : column.key !== 'action' ? (
                            <span className="text-dark fw-medium">
                              {itemIssue[column.key] ?? '-'}
                            </span>
                          ) : null}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            {itemIssues.length > 0 && (
              <div className="p-3 border-top bg-white">
                <TablePagination
                  meta={meta}
                  handlePageChange={handlePageChange}
                  handleOnChangeMeta={handleOnChangeMeta}
                />
              </div>
            )}
          </Card>
        </div>
      </div>

      <ModalItemIssue
        show={visible}
        onHide={() => setVisible(false)}
        refreshData={() => getData()}
        data={{
          filter: filter,
          selectedID: selectedID,
          selectedItems: itemIssues.filter((issue) =>
            selectedID.some((sel) => sel.id === issue.issue_id)
          )
        }}
        onResetSelect={handleResetSelectedID}
      />
      <ModalStockAdjustment
        show={
          ModalManualStockOpnameProp().key
            ? visibleManualStockOpname[ModalManualStockOpnameProp().key]
            : false
        }
        onHide={() => handleModalManualStockOpname()}
        title={ModalManualStockOpnameProp().title}
        size="md"
        backdrop="static"
      >
        <Modal.Body className="my-2">
          {ModalManualStockOpnameProp().key === 'confirm' && (
            <>
              <div className="p-2 mt-3 text-center">
                <div className="d-flex justify-content-center">
                  <svg
                    width="181"
                    height="180"
                    viewBox="0 0 181 180"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                      fill="#828282"
                    />
                    <path
                      d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                      fill="#828282"
                    />
                  </svg>
                </div>
                <div className="my-3">
                  <p>Create Manual Stock Opname ticket?</p>
                  <p>Make sure there is no activities related to this item</p>
                </div>
              </div>
            </>
          )}
          {ModalManualStockOpnameProp().key === 'form' && (
            <div className="my-2">
              <Col md={12}>
                <Form.Label
                  className="text-muted text-uppercase fw-bold"
                  htmlFor="warehouse"
                >
                  PIC
                </Form.Label>
                <Select
                  isClearable
                  id="pic"
                  defaultValue={formManualStockOpname.pics || []}
                  styles={customStyles}
                  onChange={(e) => {
                    if (!e) {
                      e = {
                        target: refPics,
                        value: ''
                      }
                    }
                    handleForm(e || [], 'pics')
                  }}
                  options={users.pics || []}
                  placeholder="Select PIC"
                  isSearchable
                  ref={refPics}
                  isMulti
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </Col>
              <Col md={12} className="my-2 mb-4">
                <Form.Label
                  className="text-muted text-uppercase fw-bold"
                  htmlFor="warehouse"
                >
                  checker
                </Form.Label>
                <Select
                  isClearable
                  id="checker"
                  defaultValue={formManualStockOpname.checkers || []}
                  styles={customStyles}
                  onChange={(e) => {
                    if (!e) {
                      e = {
                        target: refCheckers,
                        value: ''
                      }
                    }
                    handleForm(e || null, 'checkers')
                  }}
                  options={users.checkers || []}
                  placeholder="Select Checker"
                  isSearchable
                  ref={refCheckers}
                  isMulti
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </Col>
            </div>
          )}
          <Modal.Footer>
            <hr />
            {ModalManualStockOpnameProp()?.footer}
          </Modal.Footer>
        </Modal.Body>
      </ModalStockAdjustment>
    </Container>
  )
}

export default ItemIssue
